<template>
  <div class="fail-message">
   {{ failMessage }}
  </div>
</template>

<script>
export default {
  name: 'VinFailContent',
  props: {
    failMessage: {
      type: String,
      default: '查询失败，请稍后重试'
    },
    questions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleQuestionClick(item) {
      // 触发点击事件，让父组件处理
      this.$emit('question-click', item)
    }
  }
}
</script>

<style lang="less">
/* 引入共享样式 */
@import "./shared.less";
</style>

<style scoped lang="less">

</style>